//#region Libraries
//#endregion
//#region Styles
import { TitleSection } from "components/styles";
import { Container } from "./styles";
//#endregion
//#region Components
import CloseButton from "components/CloseButton/CloseButton";
import HistoryTable from "../HistoryTable/HistoryTable";
import CustomDialogAlert from "components/DialogAlert/v2";
import NotificationNoContent from "components/NotificationNoContent/NotificationNoContent";
//#endregion

const DialogChangeHistory = ({
    dialog, changeHistory,
    data: {
        student, form
    }
}) => {
    const { campusSpaceId, reasonForPenalizeId } = form;
    const isEmptyHistory = !changeHistory || changeHistory.length === 0;
    return (
        <CustomDialogAlert dialog={dialog}>
            <CloseButton onClick={() => dialog.hide()} />
            <Container className={isEmptyHistory ? "empty" : ""}>
                {student &&
                    <TitleSection
                        fontWeight="900"
                        textAlign="center">Historial de cambios - {student.id} ({student.name})</TitleSection>}
                {!isEmptyHistory
                    ? <HistoryTable
                        campusSpaceId={campusSpaceId}
                        reasonForPenalizeId={reasonForPenalizeId}
                        changeHistory={changeHistory} />
                    : <NotificationNoContent
                        title="Tu historial está vacío"
                        description="Cuando realices cambios quedarán registrados aquí." />}
            </Container>
        </CustomDialogAlert>
    );
}

export default DialogChangeHistory;